class CaptainVerificationPageTransform {
  constructor() {
    "ngInject";
  }
}

export default CaptainVerificationPageTransform;



// WEBPACK FOOTER //
// ./src/pages/captainVerification/captainVerification.transforms.js